module.exports = __webpack_public_path__ + "static/media/lighbulb.18c3f82f.svg";